import { ChipsInterface as ChipsI } from '../facial/types';

import { ProfilesInterface, AppUser } from '../users/types';

/*
 * Action Types
 */
export enum UserProfileTypes {
  LIST_USERPROFILE_REQUEST = '@userprofile/LIST_USERPROFILE_REQUEST',
  LIST_USERPROFILE_SUCCESS = '@userprofile/LIST_USERPROFILE_SUCCESS',
  LIST_USERPROFILE_FAILURE = '@userprofile/LIST_USERPROFILE_FAILURE',

  LIST_USERPROFILE_REQUESTS_REQUEST = '@userprofile/LIST_USERPROFILE_REQUESTS_REQUEST',
  LIST_USERPROFILE_REQUESTS_SUCCESS = '@userprofile/LIST_USERPROFILE_REQUESTS_SUCCESS',
  LIST_USERPROFILE_REQUESTS_FAILURE = '@userprofile/LIST_USERPROFILE_REQUESTS_FAILURE',

  LIST_USERPROFILE_AVAILABLE_REQUEST = '@userprofile/LIST_USERPROFILE_AVAILABLE_REQUEST',
  LIST_USERPROFILE_AVAILABLE_SUCCESS = '@userprofile/LIST_USERPROFILE_AVAILABLE_SUCCESS',
  LIST_USERPROFILE_AVAILABLE_FAILURE = '@userprofile/LIST_USERPROFILE_AVAILABLE_FAILURE',

  UPDATE_USERPROFILE_REQUEST = '@userprofile/UPDATE_USERPROFILE_REQUEST',
  UPDATE_USERPROFILE_SUCCESS = '@userprofile/UPDATE_USERPROFILE_SUCCESS',
  UPDATE_USERPROFILE_FAILURE = '@userprofile/UPDATE_USERPROFILE_FAILURE',

  UPDATE_USERPROFILE_STATUS_REQUEST = '@userprofile/UPDATE_USERPROFILE_STATUS_REQUEST',
  UPDATE_USERPROFILE_STATUS_SUCCESS = '@userprofile/UPDATE_USERPROFILE_STATUS_SUCCESS',
  UPDATE_USERPROFILE_STATUS_FAILURE = '@userprofile/UPDATE_USERPROFILE_STATUS_FAILURE',

  UPDATE_USERPROFILE_REQUESTS_REQUEST = '@userprofile/UPDATE_USERPROFILE_REQUESTS_REQUEST',
  UPDATE_USERPROFILE_REQUESTS_SUCCESS = '@userprofile/UPDATE_USERPROFILE_REQUESTS_SUCCESS',
  UPDATE_USERPROFILE_REQUESTS_FAILURE = '@userprofile/UPDATE_USERPROFILE_REQUESTS_FAILURE',

  REQUEST_USERPROFILE_REQUEST = '@userprofile/REQUEST_USERPROFILE_REQUEST',
  REQUEST_USERPROFILE_SUCCESS = '@userprofile/REQUEST_USERPROFILE_SUCCESS',
  REQUEST_USERPROFILE_FAILURE = '@userprofile/REQUEST_USERPROFILE_FAILURE',

  UPDATE_USERPROFILE_DATA_REQUEST = '@userprofile/UPDATE_USERPROFILE_DATA_REQUEST',
  UPDATE_USERPROFILE_DATA_SUCCESS = '@userprofile/UPDATE_USERPROFILE_DATA_SUCCESS',
  UPDATE_USERPROFILE_DATA_FAILURE = '@userprofile/UPDATE_USERPROFILE_DATA_FAILURE',

  REQUEST_USERPROFILE_ATTACHMENT_REQUEST = '@userprofile/REQUEST_USERPROFILE_ATTACHMENT_REQUEST',
  REQUEST_USERPROFILE_ATTACHMENT_SUCCESS = '@userprofile/REQUEST_USERPROFILE_ATTACHMENT_SUCCESS',
  REQUEST_USERPROFILE_ATTACHMENT_FAILURE = '@userprofile/REQUEST_USERPROFILE_ATTACHMENT_FAILURE',

  REQUEST_USERPROFILE_EXPIRATION_REQUEST = '@userprofile/REQUEST_USERPROFILE_EXPIRATION_REQUEST',
  REQUEST_USERPROFILE_EXPIRATION_SUCCESS = '@userprofile/REQUEST_USERPROFILE_EXPIRATION_SUCCESS',
  REQUEST_USERPROFILE_EXPIRATION_FAILURE = '@userprofile/REQUEST_USERPROFILE_EXPIRATION_FAILURE',

  CREATE_CHIPS_LIST = '@userprofile/CREATE_CHIPS_LIST',
  CLEAN_CHIPS_LIST = '@userprofile/CLEAN_CHIPS_LIST',
  CURRENT_CARD = '@userprofile/CURRENT_CARD',

  DOCUMENTS_LIST = '@userprofile/DOCUMENTS_LIST',

  USER_PROFILE_IMPORT_REQUEST = '@userprofile/USER_PROFILE_IMPORT_REQUEST',
  USER_PROFILE_IMPORT_SUCCESS = '@userprofile/USER_PROFILE_IMPORT_SUCCESS',
  USER_PROFILE_IMPORT_FAILURE = '@userprofile/USER_PROFILE_IMPORT_FAILURE',

  USER_PROFILE_LIST_IMPORTS_REQUEST = '@userprofile/USER_PROFILE_LIST_IMPORTS_REQUEST',
  USER_PROFILE_LIST_IMPORTS_SUCCESS = '@userprofile/USER_PROFILE_LIST_IMPORTS_SUCCESS',
  USER_PROFILE_LIST_IMPORTS_FAILURE = '@userprofile/USER_PROFILE_LIST_IMPORTS_FAILURE',

  USER_PROFILE_MANUAL_RELEASE_REQUEST = '@userprofile/USER_PROFILE_MANUAL_RELEASE_REQUEST',
  USER_PROFILE_MANUAL_RELEASE_SUCCESS = '@userprofile/USER_PROFILE_MANUAL_RELEASE_SUCCESS',
  USER_PROFILE_MANUAL_RELEASE_FAILURE = '@userprofile/USER_PROFILE_MANUAL_RELEASE_FAILURE',

  USER_PROFILE_RENEW_PAYMENT_REQUEST = '@userprofile/USER_PROFILE_RENEW_PAYMENT_REQUEST',
  USER_PROFILE_RENEW_PAYMENT_SUCCESS = '@userprofile/USER_PROFILE_RENEW_PAYMENT_SUCCESS',
  USER_PROFILE_RENEW_PAYMENT_FAILURE = '@userprofile/USER_PROFILE_RENEW_PAYMENT_FAILURE',
  USER_PROFILE_RENEW_PAYMENT_RESET = '@userprofile/USER_PROFILE_RENEW_PAYMENT_RESET',
}

/*
 * Data types
 */
export interface ProfileInterface {
  id: string;
  name: string;
}

export interface UserProfileHistoryInterface {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  userProfileRequestId: string;
}

export interface UserProfileRequest {
  id: string;
  type: number;
  createdAt: string;
  updatedAt: string;
  userProfileId: string;
  UserProfileRequestHistories: UserProfileHistoryInterface[];
}

export interface UserProfileInterface {
  id: string;
  status: number;
  data: string;
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
  profileId: string;
  Profile: ProfileInterface;
  userId: string;
  UserProfileRequest: UserProfileRequest;
}

export interface DocumentsInterface {
  resourceType: string;
  value: string;
  status: number;
  attachment: string[];
  message?: string;
  title?: string;
}

export interface UserProfileRequestInterface {
  id: string;
  status: number;
  type: number;
  data: object;
  createdAt: string;
  updatedAt: string;
  userProfileId: string;
  UserProfile: UserProfileInterface;
  documents: DocumentsInterface[];
  user: AppUser;
  profile: ProfilesInterface & {
    status: number;
  };
}

type RequiredTypes = 'resourceType' | 'attachment' | 'value';

export interface UserProfileListRequirementsInterface {
  group: string;
  schemaType: string;
  type: object;
  required: Array<RequiredTypes>;
  properties: {
    resourceType: {
      type: string;
      const: string;
    };
    attachment: {
      type: string;
    };
    value: {
      type: string;
    };
  };
}

export interface UserProfileRequestAttachment {
  photoUrl: string;
  publicPhotoUrl: string;
}

export interface UserProfileListAvailableInterface {
  profileId: string;
  name: string;
  requirements: UserProfileListRequirementsInterface[];
}

export interface ChipsInterface extends ChipsI {}

export interface DocumentsListInterface {
  resourceType: string;
  status: number;
  reason: number;
  message: string;
  title?: string;
}

export interface userProfileListImportsDataInterface {
  id: string;
  name: string;
  cpf: string;
  status: string;
  error: string;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  userProfileId: string;
  transportCardId: string;
  retries: number;
  filename: string;
}

export interface RenewalPaymentData {
  userProfileId: string;
  value: number;
  paymentId: string;
  paymentStatus: number;
  qrCode: string | null;
  expirationTime: number | null;
}

/*
 * State type
 */
export interface UserProfileState {
  readonly userProfileList: UserProfileInterface[];
  readonly userProfileListImportsData: userProfileListImportsDataInterface[];
  readonly userProfileListRequest: UserProfileRequestInterface[];
  readonly userProfileListAvailable: UserProfileListAvailableInterface[];
  readonly userProfileData: UserProfileInterface;
  readonly userProfileAttachmentList: UserProfileRequestAttachment;
  readonly currentCard: number;
  readonly chipsList: ChipsInterface[];
  readonly documentsList: DocumentsListInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly statusLoading: boolean;
  readonly error: boolean;
  readonly renewalPaymentData: RenewalPaymentData | null;
}
